import { AsyncPipe, NgForOf, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { PersonalManagerStates, PersonalManagersList } from '@my-account/const';
import { PersonalManagerService } from '@my-account/feature';
import { SdvorLinkComponent } from '@sdvor/shared/ui';
import { SdvorButtonComponent } from '@sdvor/shared/ui/v2';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PersonalManagerTemplateComponent } from '../index';

@Component({
  selector: 'sd-personal-managers',
  templateUrl: './personal-managers.component.html',
  styleUrls: ['./personal-managers.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgIf,
    SdvorLinkComponent,
    RouterLink,
    NgForOf,
    PersonalManagerTemplateComponent,
    AsyncPipe,
    SdvorButtonComponent,
  ],
})
export class PersonalManagersComponent implements OnInit {
  managerStates$: Observable<PersonalManagerStates>;
  personalManagers$: Observable<PersonalManagersList>;

  constructor(private personalManagerService: PersonalManagerService) {}

  ngOnInit(): void {
    this.personalManagerService.loadManagersList();
    this.personalManagers$ = this.personalManagerService.getManagersListUnconfirmedFirst();

    this.managerStates$ = this.personalManagers$.pipe(
      map((personalManagersList) => {
        const managerStates: PersonalManagerStates = {};
        if (!personalManagersList) {
          return managerStates;
        }
        personalManagersList.personalManagers.forEach((manager) => {
          managerStates[manager.uid] = {
            loadingApprove$: this.personalManagerService.getApprovementManagerLoading(manager.uid),
            loadingRevoke$: this.personalManagerService.getRevocationManagerLoading(manager.uid),
            loadingDelete$: this.personalManagerService.getDeleteManagerLoading(manager.uid),
            errorApprove$: this.personalManagerService.getApprovementManagerError(manager.uid),
            errorRevoke$: this.personalManagerService.getRevocationManagerError(manager.uid),
            errorDelete$: this.personalManagerService.getDeleteManagerError(manager.uid),
          };
        });

        return managerStates;
      }),
    );
  }

  approveManager(uid: string): void {
    this.personalManagerService.approveManager(uid);
  }

  deleteManager(uid: string): void {
    this.personalManagerService.deleteManager(uid);
  }
}
